import { ClassicEditor, Context, Bold ,Font,Essentials, Italic, Paragraph, ContextWatchdog , Image,WordCount, SourceEditing, Link, Heading,ImageToolbar, ImageUpload, ImageResize, MediaEmbed,Alignment, Indent, IndentBlock } from 'ckeditor5';
import { CKEditor, CKEditorContext } from '@ckeditor/ckeditor5-react';

import 'ckeditor5/ckeditor5.css';

    function Editor({ onChange, dataValue }) {

        console.log("value", dataValue)
    return (
        <CKEditorContext context={ Context } contextWatchdog={ ContextWatchdog }>
        <CKEditor
            editor={ ClassicEditor }
            
            config={ {
                
            plugins: [ Essentials, Bold, Font, Italic, Paragraph, Image ,WordCount, Link, SourceEditing, Heading , ImageToolbar, ImageUpload, ImageResize, MediaEmbed],
            toolbar: {
                items: [
                    'undo', 'redo', '|', 'bold', 'italic', '|',
                    'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor','link','heading',
                    'sourceEditing','wordCount','insertImage', 'mediaEmbed','Alignment','Indent', 'IndentBlock'
                ]
            },
            allowedContent: true,
            extraAllowedContent: '*(*);*{*}',
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        attributes: true,
                        classes: true,
                        styles: true
                    }
                ]
            }
            } }
            data={dataValue !=undefined ? dataValue: ''}

            onReady={ ( editor ) => {
            // You can store the "editor" and use when it is needed.
            console.log( 'Editor 1 is ready to use!', editor );
            console.log("from editor", dataValue)
            
            editor.ui.view.editable.element.style.height = '400px';
            
            } }
            onChange={(event, editor) => {
            editor.ui.view.editable.element.style.height = '400px';
                
                const data = editor.getData();      
                onChange(data);
            }}
            onFocus={(event, editor) => {
                editor.ui.view.editable.element.style.height = '400px';

            }}
            
            onBlur={(event, editor) => {
                editor.ui.view.editable.element.style.height = '400px';

            }}
        />

        </CKEditorContext>
    );
    }

export default Editor;